<template>
  <div>
    <div class="mb-8 ml-1">
      <input
        id="change-password"
        v-model="showPasswordForm"
        type="checkbox"
        name="change-password"
        :value="true"
      >
      <label
        for="change-password"
        v-text="'Change Password'"
      />
    </div>
    <Transition name="fade">
      <div
        v-if="showPasswordForm"
        class="mb-8 bg-white p-6 rounded shadow"
      >
        <ProfileField
          id="user-password"
          v-model="password"
          label="New Password"
          :error="errors.get('password')"
          type="password"
        />
        <ProfileField
          id="password-confirm"
          v-model="passwordConfirmation"
          label="Confirm New Password"
          type="password"
        />
        <div class="text-xs -mt-2 mb-2">
          <strong v-text="'Note:'" />
          Your password must be at least ten characters long and contain a minimum of one special character, capital letter, and number.
        </div>
      </div>
    </Transition>
  </div>
</template>

<script type="text/babel">
import ProfileField from './ProfileField'

export default {
  name: 'UpdatePasswordField',
  components: {
    ProfileField,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showPasswordForm: false,
    }
  },
  computed: {
    password: {
      get() {
        return this.value.password
      },
      set(value) {
        return this.emit({ password: value })
      },
    },
    passwordConfirmation: {
      get() {
        return this.value.password_confirmation
      },
      set(value) {
        return this.emit({ password_confirmation: value })
      },
    },
  },
  methods: {
    emit(data) {
      this.$emit('input', {
        ...{
          password: this.value.password,
          password_confirmation: this.value.password_confirmation,
        },
        ...data,
      })
    },
  },
}
</script>
